module.exports = __webpack_public_path__ + "static/media/comma.9658c53a.png";